// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3P7Wy","col":"Table_col__LEbel","fulfillmentStatus":"Table_fulfillmentStatus__1VkxT","emailCol":"Table_emailCol__WH0fK"};